// src/components/QaErrorRegion.jsx
export default function QaErrorRegion({
  qa = 'global',      // stable locator base, e.g. "home-products"
  message = '',       // string or falsy
  type = 'error',     // "error" | "success" | "info"
}) {
  const base = `qa-${qa}-alert`;
  const visible =
    type === 'error'
      ? 'border-red-200 bg-red-50 text-red-700'
      : type === 'success'
      ? 'border-green-200 bg-green-50 text-green-700'
      : 'border-blue-200 bg-blue-50 text-blue-700';

  return (
    <div
      data-qa={base}
      role="alert"
      aria-live="polite"
      // Always mounted: visually hidden when empty so Selenium has a stable node
      className={
        message
          ? `mb-4 rounded-lg border px-3 py-2 text-sm ${visible}`
          : 'sr-only'
      }
    >
      {message || ' '}
    </div>
  );
}
